import { createSlice } from '@reduxjs/toolkit'

export const catalogSlice = createSlice({
    name: 'catalog',
    initialState: {
        items: {

        },
        error: null,
    },
    reducers: {
        setCatalogItems: (state, action) => {
            const items = action.payload.items
            const group = action.payload.group
            const language = action.payload.language
            if (state.items[group]) {
                state.items[group][language] = items
            } else {
                state.items[group] = {}
                state.items[group][language] = items
            }

            state.error = null;
        },

        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },

    },

});
export const { setCatalogItems, setError } = catalogSlice.actions
export default catalogSlice.reducer;